module.exports = __webpack_public_path__ + "static/media/scheduleSampleUpload.54e8d88a.xlsx";